import { Form, IForm } from './Form';
import authorize, {authorizeMap} from '@/services/Authorize';

export default class CertificateForm extends Form {

    public static certificateFormFromAPI(certificate: any): CertificateForm {
        const certificateForm: CertificateForm =
            new CertificateForm({
                id: certificate.id,
                uniqueId: certificate.uniqueId,
                status: certificate.status,
                submitted: certificate.submitted,
                submittedUserId: certificate.submittedUserId,
                updatedByUserId: certificate.updatedByUserId,
                updated: certificate.updated,
                jobCorpsCenterId: certificate.jobCorpsCenterId,
                type: certificate.type,
                actionLevel: certificate.actionLevel,
                action: certificate.action
            } as IForm);
        certificateForm.setAllFields(certificate);
        return certificateForm;
    }

    public certificationId?: number;
    public instructorId?: number;
    public printAtITC?: boolean;
    public certificateIds?: number[];
    public studentIds?: number[];
    public printingComplete?: Date;

    public canPrint(): boolean {
        let canPrint: boolean = false;
        if (this.status !== 'Completed' &&
            authorize(authorizeMap(this.actionLevel ? this.actionLevel : ''))) {
            canPrint = true;
        }
        return canPrint;
    }

    private setAllFields(certificateForm: any) {
        this.id = certificateForm.id;
        this.uniqueId = certificateForm.uniqueId;
        this.status = certificateForm.status;
        this.submittedUserId = certificateForm.submittedUserId;
        this.submitted = certificateForm.submitted;
        this.updated = certificateForm.updated;
        this.updatedByUserId = certificateForm.updatedByUserId !== 0 ? certificateForm.updatedByUserId : undefined;
        this.type = certificateForm.type ? certificateForm.type.replace('_', ' ') : undefined;
        this.actionLevel = certificateForm.actionLevel;
        this.certificationId = certificateForm.certificationId;
        this.jobCorpsCenterId = certificateForm.jobCorpsCenterId;
        this.instructorId = certificateForm.instructorId;
        this.printAtITC = certificateForm.printAtITC;
        this.certificateIds = certificateForm.certificateIds !== null ?
            certificateForm.certificateIds : [];
        this.studentIds = certificateForm.studentIds !== null ?
            certificateForm.studentIds : [];
        this.printingComplete = certificateForm.printingComplete;
    }
}
